import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BlogData from "../../data/blog/BlogData.json";
import { slugify } from "../../utils";
import {
  FaPlay,
  FaAngleRight,
  FaAngleLeft,
  FaArrowRight,
  FaArrowLeft,
} from "react-icons/fa";
import FsLightbox from "fslightbox-react";
import Slider from "react-slick";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { media_url, useBlog } from "../../hooks/useBlog";

const allBlogData = BlogData;

const BlogGridOne = () => {
  const { posts, postsPages, postsCount } = useSelector((state) => state.blog);
  const initialized = useRef(false);
  const { getPosts } = useBlog();
  const [viewState, setViewState] = useState({
    currentPostPage: 1,
    pageSize: 5,
  });

  const [toggler, setToggler] = useState(false);

  function SlickNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <FaAngleRight />
      </div>
    );
  }

  function SlickPrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <FaAngleLeft />
      </div>
    );
  }

  var slideSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SlickNextArrow />,
    prevArrow: <SlickPrevArrow />,
  };

  const [blogs] = useState(allBlogData);
  const [pageNumber, setPageNumber] = useState(0);

  const blogsPerPage = 4;
  const pageVisited = pageNumber * blogsPerPage;

  const pageCount = Math.ceil(blogs.length / blogsPerPage);

  const changePage = ({ selected }) => {
    setViewState((prev) => ({
      ...prev,
      currentPostPage: selected + 1,
    }));
    // setPageNumber(selected);
  };

  useEffect(() => {
    getPosts(viewState.currentPostPage, viewState.pageSize);
  }, [viewState.currentPostPage]);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getPosts(viewState.currentPostPage, viewState.pageSize);
    }
  }, []);

  return (
    <>
      {posts?.map((data) => (
        <div className="blog-grid" key={data.id}>
          <h3 className="title">
            <Link
              to={
                process.env.PUBLIC_URL +
                `/post/${slugify(data.title)}?id=${data.id}`
              }
            >
              {data.title}
            </Link>
          </h3>
          <div className="author">
            {/* <div className="author-thumb">
                            <img src={`${process.env.PUBLIC_URL}/${data.author_avatar}`} alt="Blog Author" />
                        </div> */}
            <div className="info">
              {/* <h6 className="author-name">
                                <Link to={process.env.PUBLIC_URL + `/archive/${slugify(data.author_name)}`}>{data.author_name}</Link>
                            </h6> */}
              <ul className="blog-meta list-unstyled">
                <li>
                  Creado: {/* show date like Lunes, 24-01-2025 10:15AM */}
                  {new Date(data.created).toLocaleDateString("es-ES", {
                    weekday: "long",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </li>

                <li>
                  Actualizado:{" "}
                  {new Date(data.updated).toLocaleDateString("es-ES", {
                    weekday: "long",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </li>
              </ul>
            </div>
          </div>
          <div className="post-thumbnail">
            {Array.isArray(data.images) ? (
              <Slider {...slideSettings} className="slick-arrow-nav">
                {data.images.map((data, index) => (
                  <div className="slide-item" key={index}>
                    <img src={`${process.env.PUBLIC_URL}/${data}`} alt="Blog" />
                  </div>
                ))}
              </Slider>
            ) : (
              <Link
                to={
                  process.env.PUBLIC_URL +
                  `/post/${slugify(data.title)}?id=${data.id}`
                }
              >
                <img src={media_url(data.image)} alt="Blog" />
              </Link>
            )}

            {/* {data.format === "video" ?
                        <>
                            <div className="popup-video">
                                <button className="play-btn" onClick={ () => setToggler(!toggler) }><FaPlay /></button>
                            </div> 
                            <FsLightbox toggler={ toggler } sources={ ['https://www.youtube.com/watch?v=1iIZeIy7TqM'] }/>
                        </> 
                        : ""
                        }   */}
          </div>
          <p>{data.excerpt}</p>
          <Link
            className="gc-btn btn-borderd btn-large"
            to={
              process.env.PUBLIC_URL +
              `/post/${slugify(data.title)}?id=${data.id}`
            }
          >
            Leer Más
          </Link>
        </div>
      ))}

      <ReactPaginate
        previousLabel={<FaArrowLeft />}
        nextLabel={<FaArrowRight />}
        pageCount={postsPages}
        onPageChange={changePage}
        containerClassName={"pagination justify-content-start"}
        previousLinkClassName={"prev"}
        nextLinkClassName={"next"}
        disabledClassName={"disabled"}
        activeClassName={"current"}
      />
    </>
  );
};

export default BlogGridOne;
